<template>
  <div class="cell cell-id cell-id-icons flex-centering" :class="{ open }">
    <v-menu absolute offset-y>
      <template v-slot:activator="{ on, attrs }">
        <div class="cell-id-number">{{ number }}</div>
        <div v-if="removable" v-bind="attrs" class="btn-circle btn-circle-table" v-on="on">
          <HorizontalDotsIcon class="icon-svg primary-500-icon" />
        </div>
      </template>
      <div class="dropdown-body dropdown-body_fit">
        <DropdownMenuElement @click.native="$emit('remove')">
          {{ $t('Delete row') }}
          <template slot="icon">
            <Icon type="trash" size="16" />
          </template>
        </DropdownMenuElement>
      </div>
    </v-menu>

    <div v-if="errorsAmount" class="absolute-wrap">
      <Dropdown
        v-model="open"
        trigger-class="error-toggle"
        dropdown-class="drop-list drop-list-left error-list"
        open-on-hover
        :position="index < 3 ? 'top left' : 'bottom left'"
      >
        <template #trigger>
          <button class="error-btn w-inline-block">!</button>
        </template>
        <template>
          <div>
            <strong>{{ errorsTitle }}</strong>
          </div>
          <ul role="list" class="error-list">
            <li v-for="(error, i) in errors" :key="i" class="error-list-item">
              <div>{{ error.description }}</div>
              <div v-if="error.where" class="grey">
                {{ error.where }}
              </div>
            </li>
          </ul>
        </template>
      </Dropdown>
    </div>
  </div>
</template>

<script>
  import { IuiDropdown as Dropdown } from 'industrial-ui-vue';
  import pluralize from '@/utils/formatting/pluralize';
  import HorizontalDotsIcon from '@/assets/icons/horizontal-dots.svg';
  import { VMenu } from 'vuetify/lib';
  import DropdownMenuElement from '@/components/ui/dropdown-menu/DropdownMenuElement';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'ImportCellId',
    components: { Dropdown, HorizontalDotsIcon, DropdownMenuElement, VMenu, Icon },
    props: {
      number: [String, Number],

      index: Number,

      removable: {
        type: Boolean,
        default: true,
      },

      errorsAmount: {
        type: Number,
        default: 0,
      },

      errors: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        open: false,
      };
    },
    computed: {
      errorsTitle() {
        return `${this.errorsAmount} ${pluralize(this.errorsAmount, 'error')} in this row`;
      },
    },
  };
</script>
<style scoped>
  .error-btn {
    display: flex;
    width: 24px;
    height: 24px;
    padding: 0;
    justify-content: center;
    align-items: center;
    border-style: solid;
    border-width: 1px;
    border-color: #e54444;
    border-radius: 4px;
    background-color: #e54444;
    transition: all 200ms ease;
    color: #fff;
    text-decoration: none;
  }

  .error-btn:hover {
    background-color: #db3c3c;
  }

  .absolute-wrap {
    position: absolute;
    left: 40px;
    top: 10px;
  }
</style>
